import type { GeneratedFileInfo } from '@newfront-insurance/ai-api';
import type { ToolUIPart } from 'ai';

import { GeneratedFilesList } from './process-files-tool';

interface ToolInvocationPart {
  type: string;
  state?: string;
  toolCallId?: string;
  output?: {
    generatedFiles?: Array<GeneratedFileInfo>;
    generatedFileUuids?: string[];
  };
}

/**
 * Helper function to render generated files from tool output
 */
function renderGeneratedFiles(output: ToolInvocationPart['output']): React.ReactNode | null {
  if (!output) return null;

  // Use generated files from Files service
  if (output.generatedFiles && output.generatedFiles.length > 0) {
    const generatedFiles = output.generatedFiles.map((file) => ({
      uuid: file.fileUuid,
      filename: file.filename,
    }));
    return <GeneratedFilesList files={generatedFiles} />;
  }

  // Fallback to generatedFileUuids
  if (output.generatedFileUuids && output.generatedFileUuids.length > 0) {
    const generatedFiles = output.generatedFileUuids.map((uuid, idx) => ({
      uuid,
      filename: `Generated file ${idx + 1}`,
    }));
    return <GeneratedFilesList files={generatedFiles} />;
  }

  return null;
}

interface FormFillingToolProps {
  part: ToolUIPart;
}

/**
 * Component for rendering formFilling tool output.
 */
export function FormFillingTool({ part }: FormFillingToolProps) {
  // Handle output
  if (part.state === 'output-available' && (part as ToolInvocationPart).output) {
    return renderGeneratedFiles((part as ToolInvocationPart).output);
  }

  return null;
}
